
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12 23.25c6.213 0 11.25-5.037 11.25-11.25S18.213.75 12 .75.75 5.787.75 12 5.787 23.25 12 23.25zm2.25-6.75h-.75A1.5 1.5 0 0112 15v-3.75a.75.75 0 00-.75-.75h-.75","stroke":"#373534","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.625 6l.123.007a1.125 1.125 0 11-.246 0L11.625 6z","fill":"#111"}})])])
          )
        }
      }
    